module.exports = __webpack_public_path__ + "img/directiq-logo.a532c316.svg";